import axios from "axios";
import router from "../../router";
import Role from '../../helpers/Role';

export default {
    namespaced: true,
    state: {
        authenticated: false,
        user: null,
        error: ''
    },
    getters: {
        authenticated(state) {
            return state.authenticated
        },
        user(state) {
            return state.user;
        },
        error(state) {
            return state.error;
        },
        isAdmin(state) {
            return state.user.role.name === Role.Admin;
        },
        isSuperAdmin(state) {
            return state.user.role.name === Role.SuperAdmin;
        },
        isSchoolAdmin(state) {
            return state.user.role.name === Role.SchoolAdmin;
        },
        isTeacher(state) {
            return state.user.role.name === Role.Teacher
        }
    },
    mutations: {
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value;
        },
        SET_USER(state, value) {
            state.user = value;
        },
        SET_ERROR(state, value) {
            state.error = value;
        },
        CLEAR_ERROR(state) {
            state.error = '';
        }
    },
    actions: {
        async login({ commit }, credentials) {
            try {
                const hasCsrfCookie = document.cookie.split(';').some(item => item.trim().startsWith('XSRF-TOKEN='));
                if (!hasCsrfCookie) {
                    await axios.get('/sanctum/csrf-cookie')
                }
                const response = await axios.post('/api/admin/login', credentials)
                commit('CLEAR_ERROR');
                commit('SET_AUTHENTICATED', true)
                commit('SET_USER', response.data.user)
                router.push({ name: 'schools' });
            } catch (e) {
                const res = e && e.response;
                if (!res) {
                    return commit('SET_ERROR', 'Backend not reachable. Is Laravel running on http://localhost:8000 ?');
                }

                // Laravel validation responses are usually { message, errors: { field: [msg] } }
                const data = res.data || {};
                const firstValidationError =
                    data.errors && Object.values(data.errors).flat && Object.values(data.errors).flat()[0];

                return commit('SET_ERROR', firstValidationError || data.message || `Request failed (${res.status})`);
            }
        },
        async logout({ commit }) {
            await axios.post('/api/admin/logout')

            commit('SET_AUTHENTICATED', false)
            commit('SET_USER', null)
        },

        me({ commit }) {
            return axios.get('/api/me').then((response) => {
                commit('SET_AUTHENTICATED', true)
                commit('SET_USER', response.data)
            }).catch(() => {
                commit('SET_AUTHENTICATED', false)
                commit('SET_USER', null)
            })
        }
    }
}